import { render } from "./Favorite-Block.vue?vue&type=template&id=75151470"
import script from "./Favorite-Block.vue?vue&type=script&lang=js"
export * from "./Favorite-Block.vue?vue&type=script&lang=js"

import "./Favorite-Block.vue?vue&type=style&index=0&id=75151470&lang=scss"

import exportComponent from "/home/kostas/projects_on_os/coin-data-collectors-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__